import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { CalendarDays, Warehouse } from "lucide-react";
import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";
import { flatNav } from "./navItems";
import { useAuth } from "@/context/AuthContext";
import { BrandIcon } from "@/components/bakery/Art";
import { fmtDateLong, todayJkt } from "@/lib/format";

function Topbar() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const current = flatNav(user).filter((n) => pathname === n.to || (n.to !== "/" && pathname.startsWith(n.to))).sort((a, b) => b.to.length - a.to.length)[0];
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center gap-3 border-b border-zinc-200 bg-white/90 px-4 backdrop-blur-md md:px-8" data-testid="topbar">
      <BrandIcon dark className="h-8 w-auto md:hidden" />
      <div className="min-w-0 flex-1">
        <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">Stronghold Stock</div>
        <div className="truncate font-display text-base font-bold leading-tight" data-testid="topbar-title">{current?.label || "Rak Roti"}</div>
      </div>
      <div className="hidden items-center gap-2 rounded-full border border-zinc-200 px-3 py-1.5 text-xs text-zinc-600 sm:flex">
        <CalendarDays className="h-3.5 w-3.5" /> {fmtDateLong(todayJkt())}
      </div>
      <div className="flex items-center gap-1.5 rounded-full bg-ink px-3 py-1.5 text-xs font-medium text-white" data-testid="warehouse-chip">
        <Warehouse className="h-3.5 w-3.5 text-brand" /> Pusat
      </div>
      <div className="grid h-8 w-8 place-items-center rounded-full border-2 border-ink text-xs font-bold md:hidden" title={user?.name}>
        {(user?.name || "?").slice(0, 1).toUpperCase()}
      </div>
    </header>
  );
}

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="flex min-h-screen bg-paper">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="mx-auto w-full max-w-[1500px] flex-1 px-4 pb-28 pt-6 md:px-8 md:pb-12" data-testid="main-content">
          <Outlet />
        </main>
      </div>
      <MobileNav />
    </div>
  );
}
